var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEstrutura(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#397639;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Estrutura"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.16,17.45a.37.37,0,0,1-.29-.6c.63-.77,1.24-1.54,1.85-2.3l2.44-3.06a.33.33,0,0,1,.25-.12c.72,0,1.45,0,2.17,0a.22.22,0,0,1,.23.14A2,2,0,0,1,10,12H7.66l-3.8,4.79H20.17L17.6,13.66,18,13l3.09,3.85a.36.36,0,0,1-.28.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,14a41.08,41.08,0,0,1-2.2-3.87A2.4,2.4,0,0,1,9.9,7.71a2.49,2.49,0,0,1,2.77-1A2.46,2.46,0,0,1,14.45,9a3.56,3.56,0,0,1-.4,1.43A39.83,39.83,0,0,1,12,14Zm0-6.16A1.23,1.23,0,1,0,13.22,9,1.24,1.24,0,0,0,12,7.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.49,14.54A15.61,15.61,0,0,1,15.13,12a1.32,1.32,0,0,1,.34-1.41,1.38,1.38,0,0,1,1.4-.4,1.43,1.43,0,0,1,1,1.92C17.59,12.76,16.49,14.54,16.49,14.54Zm.74-2.9a.73.73,0,0,0-.72-.73.73.73,0,0,0-.73.73.73.73,0,0,0,.73.72A.71.71,0,0,0,17.23,11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9,16.11a13.38,13.38,0,0,1-1-1.88A1.07,1.07,0,0,1,8.21,13a1.14,1.14,0,0,1,1.91.9,1.82,1.82,0,0,1-.2.61A15.38,15.38,0,0,1,9,16.11Zm0-1.69a.57.57,0,1,0-.56-.57A.56.56,0,0,0,9,14.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.68 12.24 13.77 12.24 14.22 11.38 14.57 11.38 14.68 12.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,.75A11.25,11.25,0,1,1,.75,12,11.27,11.27,0,0,1,12,.75M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstrutura);
export default __webpack_public_path__ + "static/media/estrutura.d7d1a598bb1ec488128d71bc98709438.svg";
export { ForwardRef as ReactComponent };